import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-OnlinePDB',
    templateUrl: './OnlinePDB.component.html',
    styleUrls: ['./OnlinePDB.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnlinePDBComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
